var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, OutlinedInput } from '@mui/material';
import { SimpleLoading } from './Loading';
export default function DialogSelect(props) {
    const { onSelect, title, emptyTitle, initialValue, open, setOpen, loadData } = props;
    const [dataLoading, setDataLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState('');
    const init = () => __awaiter(this, void 0, void 0, function* () {
        if (loadData) {
            setDataLoading(true);
            setData(yield loadData());
            setDataLoading(false);
        }
        else {
            setDataLoading(false);
        }
        if (initialValue) {
            setSelected(initialValue);
        }
        else {
            setSelected('');
        }
    });
    useEffect(() => {
        init();
    }, [initialValue, loadData]);
    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    };
    return (_jsx("div", { children: _jsxs(Dialog, { disableEscapeKeyDown: true, open: open, onClose: handleClose, children: [_jsx(DialogTitle, { children: title }), _jsx(DialogContent, { children: dataLoading ? (_jsx(SimpleLoading, { message: 'Loading data' })) : (_jsx(Box, { component: "form", sx: { display: 'flex', flexWrap: 'wrap' }, children: data.length == 0 ? (_jsx(_Fragment, { children: emptyTitle })) : (_jsx(FormControl, { sx: { m: 1, minWidth: 120 }, children: _jsxs(Select, { value: selected, onChange: (event) => {
                                    setSelected(event.target.value || '');
                                }, native: true, input: _jsx(OutlinedInput, { label: "Select", id: "demo-dialog-native" }), children: [_jsx("option", { value: "", children: "None" }, "none"), data.map((entry, index) => {
                                        return (_jsx("option", { value: entry.key, children: entry.value }, index));
                                    }), ' ', "as ReactNode"] }) })) })) }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: submitting, onClick: handleClose, children: "Cancel" }), data.length > 0 && (_jsxs(Button, { disabled: submitting, onClick: () => __awaiter(this, void 0, void 0, function* () {
                                setSubmitting(true);
                                try {
                                    onSelect && (yield onSelect(selected));
                                }
                                finally {
                                    setOpen(false);
                                    setSubmitting(false);
                                }
                            }), children: ["Ok ", submitting && _jsx(CircularProgress, { sx: { ml: 1 }, size: 12, color: "inherit" })] }))] })] }) }));
}
